export var makeVerticalVisualCue = (theme, size, offset) => theme.mode === 'contrast' ? {} : {
  opacity: 0,
  border: "2px solid ".concat(theme.color.background.container.default),
  borderRadius: theme.borderRadius1,
  boxSizing: 'content-box',
  content: '" "',
  height: size,
  left: "".concat(-offset, "px"),
  position: 'absolute',
  transition: 'opacity 100ms linear, background-color 100ms linear, color 100ms linear',
  width: '2px'
};
export var makeHorizontalVisualCue = (theme, size, offset) => theme.mode === 'contrast' ? {} : {
  opacity: 0,
  border: "2px solid ".concat(theme.color.background.container.default),
  borderRadius: theme.borderRadius1,
  bottom: "".concat(-offset, "px"),
  boxSizing: 'content-box',
  content: '" "',
  height: '2px',
  position: 'absolute',
  transition: 'opacity 100ms linear, background-color 100ms linear, color 100ms linear',
  width: size
};